import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { NgForm, NgModel } from '@angular/forms'
import { UiModalComponent } from 'src/app/theme/shared/components/modal/ui-modal/ui-modal.component'
import { UtilsService } from 'src/app/utils/utils.service'
import { StorageService } from 'src/app/services/storage.service'
import { SetorService } from 'src/app/services/setor.service'
import { Setor } from 'src/app/classes/Setor'

@Component({
  selector: 'app-forms-setor',
  templateUrl: './forms-setor.component.html',
  styleUrls: ['./forms-setor.component.scss']
})
export class FormsSetorComponent implements OnInit {

  @ViewChild('Modal', { static: false }) modal: UiModalComponent
  @ViewChild('formulario', { static: false }) formulario!: NgForm;
  @Output() finalizarSave: EventEmitter<void> = new EventEmitter()

  isSubmit: boolean = false
  setor: Setor = new Setor()
  carregando: boolean = false

  constructor(
    private utils: UtilsService,
    private setorService: SetorService,
    private storageService: StorageService,
  ) {}

  ngOnInit() {}

  abrirModal(setor: Setor = null): void {
    if(setor === null && !this.utils.verificarPermissaoUsuario('IncluirSetores'))
       return;
     if(setor !== null && !this.utils.verificarPermissaoUsuario('EditarSetores'))
       return;
    if (setor != null){
      this.setor = setor
    }
    else{
      this.setor = new Setor()
      this.setor.FazendaId = this.storageService.getFazenda().Id;
    }

    this.modal.show()
  }

  fecharModal(): void {
    this.modal.hide()
    this.isSubmit = false
    this.formulario.resetForm();
  }

  isCampoInvalido(campo: NgModel): boolean {
    return (
      !campo.valid &&
      (campo.dirty || campo.touched || this.isSubmit)
);
  }


  save(): void {
    this.carregando = true

    if (!this.validarForm()) return

    if (this.setor.Id) {
      this.setorService
        .putSetor(this.setor.Id, this.setor)
        .subscribe(
          (res) => {
            this.finalizarSaveRequestSuccess(
              'Setor alterado com sucesso!',
            )
          },
          (err) => {
            this.finalizarRequestError(err)
          },
        )
    } else {
      this.setorService.postSetor(this.setor).subscribe(
        (res) => {
          this.finalizarSaveRequestSuccess(
            'Setor cadastrado com sucesso!',
          )
        },
        (err) => {
          this.finalizarRequestError(err)
        },
      )
    }
  }

  validarForm(): boolean {
    if (this.formulario.invalid) {
      this.isSubmit = true
      this.carregando = false
      this.utils.handleWarning(
        'Por favor, preencha todos os campos obrigatórios corretamente.',
      )
      return false
    }

    // Validar que pelo menos um dos dois (Irrigado ou Sequeiro) esteja verdadeiro
    if (!this.setor.Irrigado && !this.setor.Sequeiro) {
      this.isSubmit = true
      this.carregando = false
      this.utils.handleWarning(
        'É obrigatório selecionar pelo menos uma opção: Irrigado ou Sequeiro.',
      )
      return false
    }

    return true
  }

  finalizarSaveRequestSuccess(msg: string): void {
    this.utils.handleSuccess(msg)
    this.carregando = false
    this.finalizarSave.emit()
    this.fecharModal()
  }

  finalizarRequestError(error: any): void {
    this.utils.getErro(error)
    this.carregando = false
  }
}

